import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export function AddServicesNotification() {
  const { t } = useTranslation('account');

  return (
    <Fragment>
      <p>{t('notifications.addData.info')}</p>
      <p className="prompt">{t('notifications.addData.prompt')}</p>
    </Fragment>
  );
};

export default AddServicesNotification;
